"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FTXFutureMarginCalculator = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const FutureMarginCalculator_1 = require("./FutureMarginCalculator");
class FTXFutureMarginCalculator extends FutureMarginCalculator_1.SingleFutureMarginCalculator {
    getMaintenanceMarginRate(position, open_price, leverage_rate) {
        const symbol = this.symbol;
        const maximumLeverages = [1, 3, 5, 10, 20, 50, 100, 101];
        let maximumLeverage = new trade_utils_lib_1.SafeDecimal(1);
        for (let i = maximumLeverages.length - 1; i >= 0; i--) {
            const cur = new trade_utils_lib_1.SafeDecimal(maximumLeverages[i]);
            if (leverage_rate.lessThanOrEqualTo(cur)) {
                maximumLeverage = cur;
            }
            else {
                break;
            }
        }
        // 文档地址: https://help.ftx.com/hc/en-us/articles/360027668832
        // IMF Factor: multiplier on the margin required for a coin.
        // Base IMF: the minimum initial margin fraction needed.  This is 1 / maximum leverage.
        // Position initial margin fraction: max(Base IMF, IMF factor * sqrt(position open size))
        // Position maintenance margin fraction: max([3% if you're using 20x maximum leverage or less, 0.60% if you're using 50x maximum leverage or more], 0.6 * position initial margin fraction)
        const baseIMF = new trade_utils_lib_1.SafeDecimal(1).div(maximumLeverage);
        let IMF_factor = 0;
        if (FutureInfo[this.symbol.base]) {
            IMF_factor = FutureInfo[this.symbol.base]["IMF_factor"];
        }
        const position_initial_margin_fraction = trade_utils_lib_1.SafeDecimal.max(baseIMF, trade_utils_lib_1.SafeDecimal.sqrt(position).mul(new trade_utils_lib_1.SafeDecimal(IMF_factor)));
        let esMarginFraction = 0;
        if (maximumLeverage.lessThanOrEqualTo(20)) {
            esMarginFraction = 0.03;
        }
        else if (maximumLeverage.lessThan(50)) {
            // 文档没给, 我们暂时也不支持10倍以上杠杆
        }
        else {
            esMarginFraction = 0.006;
        }
        const position_maintenance_margin_fraction = trade_utils_lib_1.SafeDecimal.max(esMarginFraction, new trade_utils_lib_1.SafeDecimal(0.6).mul(position_initial_margin_fraction));
        return position_maintenance_margin_fraction;
    }
    getLiquidationPrice(initMargin, openPrice, position, leverage_rate, trend) {
        // 维持保证金率
        const mmRate = this.getMaintenanceMarginRate(position, openPrice, leverage_rate);
        return FutureMarginCalculator_1.SingleFutureMarginCalculator.CalculateLiquidationPriceFunctionOne(mmRate, initMargin, openPrice, position, trend);
    }
}
exports.FTXFutureMarginCalculator = FTXFutureMarginCalculator;
const FutureInfo = {
    "BTC": {
        "IMF_factor": 0.002,
    },
    "ETH": {
        "IMF_factor": 0.0004,
    },
    "USDT": {
        "IMF_factor": 0.00001,
    },
    "EOS": {
        "IMF_factor": 0.002,
    },
    "XRP": {
        "IMF_factor": 0.00002,
    },
    "BNB": {
        "IMF_factor": 0.0005,
    },
    "TRX": {
        "IMF_factor": 0.00001,
    },
    "LEO": {
        "IMF_factor": 0.0002,
    },
    "BCH": {
        "IMF_factor": 0.0008,
    },
    "ALGO": {
        "IMF_factor": 0.00015,
    },
    "LTC": {
        "IMF_factor": 0.0004,
    },
    "BSV": {
        "IMF_factor": 0.001,
    },
    "ALT": {
        "IMF_factor": 0.0008,
    },
    "MID": {
        "IMF_factor": 0.001,
    },
    "SHIT": {
        "IMF_factor": 0.002,
    },
    "HT": {
        "IMF_factor": 0.0003,
    },
    "OKB": {
        "IMF_factor": 0.0003,
    },
    "EXCH": {
        "IMF_factor": 0.003,
    },
    "ETC": {
        "IMF_factor": 0.0002,
    },
    "TOMO": {
        "IMF_factor": 0.0002,
    },
    "ATOM": {
        "IMF_factor": 0.0005,
    },
    "XTZ": {
        "IMF_factor": 0.0004,
    },
    "TRYB": {
        "IMF_factor": 0.000002,
    },
    "MATIC": {
        "IMF_factor": 0.00004,
    },
    "DOGE": {
        "IMF_factor": 0.00002,
    },
    "BTMX": {
        "IMF_factor": 0.0001,
    },
    "ADA": {
        "IMF_factor": 0.00004,
    },
    "PAXG": {
        "IMF_factor": 0.002,
    },
    "XAUT": {
        "IMF_factor": 0.002,
    },
    "LINK": {
        "IMF_factor": 0.0004,
    },
    "DRGN": {
        "IMF_factor": 0.001,
    },
    "BRZ": {
        "IMF_factor": 0.000002,
    },
    "THETA": {
        "IMF_factor": 0.0002,
    },
    "KNC": {
        "IMF_factor": 0.001,
    },
    "PRIV": {
        "IMF_factor": 0.002,
    },
    "DEFI": {
        "IMF_factor": 0.004,
    },
    "CUSDT": {
        "IMF_factor": 0.00001,
    },
    "COMP": {
        "IMF_factor": 0.005,
    },
    "BAL": {
        "IMF_factor": 0.0025,
    },
    "MKR": {
        "IMF_factor": 0.02,
    },
    "VET": {
        "IMF_factor": 0.0001,
    },
    "SXP": {
        "IMF_factor": 0.0005,
    },
    "DMG": {
        "IMF_factor": 0.0008,
    },
    "DOT": {
        "IMF_factor": 0.01,
    },
    "RUNE": {
        "IMF_factor": 0.001,
    },
    "AMPL": {
        "IMF_factor": 0.0005,
    },
    "MTA": {
        "IMF_factor": 0.001,
    },
    "SOL": {
        "IMF_factor": 0.001,
    },
};
